// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });



//////////////////
// WEBPACK FOOTER
// /Users/m802941/.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es7.map.to-json.js
// module id = 342
// module chunks = 9